import {Spinner, VStack} from "@chakra-ui/react";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth, useChat} from "../../context";
import {InfoFetchingError} from "../../components/UI/UserSelector";
import {User} from "../../models";
import {COOKIES_COMPANY_ID, COOKIES_USER_ID, routes} from "../../helper/constants";
import {cookies} from "../../shared/session/cookies";
import {sessionConfig} from "../../session";

function storeCookie(key: string, val: string) {
    cookies.set(key, val, sessionConfig);
}


function CheckInformation() {
    const navigate = useNavigate();
    const chat = useChat();
    const auth = useAuth();

    async function userInformationCheck(user: User) {
        const newURL = localStorage.getItem("from");
        const isActualPath = routes.some((route) => route.href === newURL);
        storeCookie(COOKIES_COMPANY_ID, user.CompanyId);
        storeCookie(COOKIES_USER_ID, user.userID);
        chat.actions.setUser(user);
        if (newURL && newURL !== "/" && isActualPath) {
            navigate(`${newURL}`);
        } else {
            navigate("/request-list");
        }
        localStorage.removeItem("from");
    }
    useEffect(function () {
        if (auth.user && auth.status === "authenticated") {
            userInformationCheck(auth.user);
        }
    }, [auth.user, auth.status]);
    if (auth.status === "unauthenticated") {
        return <InfoFetchingError reload={auth.fetchUser}/>;
    }
    return <VStack h="100dvb" justifyContent={"center"}>
        <Spinner />
    </VStack>;
}

export default CheckInformation;
